import React from 'react';
import BaseForm from "./BaseForm";

function BasicConfig(props) {
    console.log("basic config here");
    return (
        <div>
            <h1 className="text-2xl">{props.title}</h1>
            <BaseForm
                showForm={true}
                formFields={props.formFields}
                dataUrl={props.dataUrl}
                onSuccess={() => {console.log("TODO - this on success handler")}}
            />
        </div>
    );
}

export default BasicConfig;